<template>
<div>
    <article class="title is-parent box">
        <h1 class="title">App Builds</h1>
        
    </article>
</div>
</template>
<script>
export default {
  name: 'AppBuilds',
  data () {
    return {
      urls: []
    }
  },
  methods: {
    fetchGamesheet () {
      this.$http
        .get('https://devilsapi.roblutken.com/api/app/get/apps', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.urls = response.data
          },
          response => {}
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// app-builds.vue?0f7ac7e8